<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-form ref="addClientForm" @submit.prevent="submitChangeOwner">
                <v-col
                    class="page-top d-flex justify-space-between"
                    cols="12"
                >
                  <div>
                    <div class="page-title">Изменения условий членства, пакета услуг</div>
                    <div class="breadcrumb"><span class="breadcrumb-bold">Ресепшен / Рабочий стол /</span> Изменения условий членства, пакета услуг</div>
                  </div>
                </v-col>
                <v-col
                    cols="12"
                >
                  <v-sheet class="card rounded-lg" style="padding: 0 !important;">
                    <div class="column" style="padding: 20px 20px 0 20px !important;">
                      <v-row>

                      <v-col
                            md="6"
                            sm="12"
                            v-if="change_owner_new_client && newclient_id"
                        >
                          <label>Клиент</label>
                          <div class="d-flex" style="align-items: center">
                            <b>{{ newclient_id.name}}</b>
                          </div>
                        </v-col>

                      <v-col
                            md="6"
                            sm="12"
                            v-else
                        >
                          <label>Клиент</label>
                          <div v-if="visitorDesktop && visitorDesktop.client" class="d-flex" style="align-items: center">
                            {{ visitorDesktop.client.name}}
                          </div>
                          <div v-else>Загрузка данных...</div>
                        </v-col>

                        <v-col
                            md="6"
                            sm="12"
                        >
                          <label>Операция</label>
                          <v-select
                              class="rounded-lg custom__select "
                              :items="operations"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              item-text="name"
                              item-value="link"
                              v-model="operation"
                              label="Выбрать"
                              append-icon="mdi-chevron-down"
                              :background-color="getBgColor(operation)"
                              color="#629f34"
                              outlined
                              dense
                              style="height: 48px;margin-top: 5px; margin-bottom: 0 !important;"
                          >
                            <template v-slot:item=" { item } ">
                              <router-link :to="{ name: item.link, params: {client_id: client_id, product_id: product_id}}" style="text-decoration: none; color: #000">
                                {{ item.name }}
                              </router-link>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                            md="6"
                            sm="12"
                        >
                          <label>Членство, пакет услуг</label>

                          <v-select
                              v-if="visitorDesktop && !closed_service_name"
                              :items="visitorDesktop.client.productes"
                              item-value="product_id"
                              item-text="product_name"
                              :rules="productRules"
                              v-model="product_id"
                              class="rounded-lg"
                              append-icon="mdi-chevron-down"
                              outlined
                              dense
                              required
                              background-color="white"
                              style="height: 48px;padding-top: 5px; flex: none !important;"
                          >
                          </v-select>
                          <v-select
                              v-else-if="closed_service_name"
                              :items="product_id_closed_items"
                              item-value="product_id"
                              item-text="product_name"
                              :rules="productRules"
                              v-model="product_id_closed"
                              class="rounded-lg"
                              append-icon="mdi-chevron-down"
                              outlined
                              dense
                              required
                              background-color="white"
                              style="height: 48px;padding-top: 5px; flex: none !important;"
                          >
                          </v-select>
                          <div v-else>Загрузка данных...</div>
                        </v-col>
                        <v-col
                            md="6"
                            sm="12"
                        >
                          <label v-if="modifierList && modifierList.data && modifierList.data.length > 0">Модификатор</label>
                          <label v-else>Модификатор (загрузка...)</label>

                          <!-- {{ document_modifier }}

                          ---

                          {{ modifierList.data }} -->

                          <v-select
                              v-if="modifierList && modifierList.data"
                              :items="modifierList.data"
                              v-model="modifier_id"
                              item-value="id"
                              item-text="name"
                              :rules="modifierRules"
                              class="rounded-lg"
                              append-icon="mdi-chevron-down"
                              outlined
                              dense
                              background-color="white"
                              return-object
                              style="height: 48px;padding-top: 5px; flex: none !important;"
                          >
                          </v-select>
                          <v-select
                              v-else
                              :items="modifierNomenclatureDef"
                              v-model="modifier_id_def"
                              item-value="id"
                              item-text="name"
                              class="rounded-lg"
                              append-icon="mdi-chevron-down"
                              outlined
                              dense
                              background-color="white"
                              return-object
                              style="height: 48px;padding-top: 5px; flex: none !important;"
                          >
                          </v-select>
                          
                        </v-col>
                      </v-row>
                    </div>
                  </v-sheet>
                </v-col>
                <v-col
                    cols="12"
                >
                  <v-sheet class="card rounded-lg">
                    <div class="column" style="display: flex; align-items:center; justify-content: space-between;">

                      <div style="display: flex; align-items:center;" v-if="operation === 'ChangeOwner'">
                            <div
                            v-if="operation === 'ChangeOwner'"
                                style="padding: 0 0 20px 0 !important;"
                            >
                              <label style="color: #629F33;">Сменить владельца на</label>
                              <v-autocomplete
                                  :rules="newClientRules"
                                  colspan="1"
                                  :items="(listClient && listClient.client) ? listClient.client : []"
                                  item-value="client_id"
                                  item-text="name"
                                  placeholder="Поиск клиентов"
                                  hide-no-data
                                  :search-input.sync="search"
                                  v-model="newclient_id"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300'}"
                                  :no-filter=true
                                  class="rounded-lg"
                                  append-icon=""
                                  hide-details
                                  outlined
                                  dense
                                  background-color="white"
                                  style="height: 48px;padding-top: 5px; width: 300px;"
                                  required
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon>mdi-magnify</v-icon>
                                </template>

                                <template v-slot:item=" { item } ">
                                  <a @click="changeUsername(item)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                                    {{ item.name }} тел.:{{ item.phone }}
                                  </a>
                                </template>
                              </v-autocomplete>

                            </div>
                          <div v-if="change_owner_new_client && newclient_id" style="margin-left:20px;">
                            
                            <!-- <router-link :to="{ name: 'CardClientNew', params: {client_id: newclient_id.id}}" style="text-decoration: none; color: #000">
                              {{ newclient_id.name }}
                            </router-link> -->

                            <router-link :to="{ name: 'CardClientNew', params: {client_id: newclient_id_to.id}}" style="text-decoration: none; color: #000">
                              {{ newclient_id_to.name }}
                            </router-link>

                          </div>


                    </div>
                      <!-- <div v-if="operation !== 'ChangeNomenclature' && modifier" style="width:20%;">Цена: {{ modifier_id.price }} </div> -->

          

                        <div
                      
                            style="padding: 0 0 20px 0 !important; width:450px;"
                            v-if="operation === 'ChangeNomenclature' || operation === 'AddService'"
                        >
                          <label style="color: #629F33;">Список номенклатур</label>
                          <v-select
                                v-if="changeNomenclatureList"
                                :items="changeNomenclatureList.data"
                                v-model="newnomenclature_id"
                                item-value="id"
                                item-text="name"
                                class="rounded-lg"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                background-color="white"
                                return-object
                                style="height: 48px;padding-top: 5px; flex: none !important;"
                                @change="getNomenclaturePrice()"
                            >
                            </v-select>

                          </div>
                          <div v-if="(operation === 'ChangeNomenclature' || operation === 'AddService') && newnomenclature_id" style="width:40%;">
                            <!-- <span>Цена: {{ newnomenclature_id.price }} </span> -->
                            <div v-if="calcChangeNomenclature && calcChangeNomenclature.data" style="display:flex; flex-direction: column;">
                              <div>Цена: {{ calcChangeNomenclature.data.sum }}</div>
                              <div>Подробности:  {{ calcChangeNomenclature.data.description }}</div>
                            </div>
                          </div>

                  <div
                      
                            style="padding: 0 0 20px 0 !important; width:450px;"
                            v-if="operation === 'ChangeTime'"
                        >
                          <label style="color: #629F33;">Изменение срока действия</label>
                            <div style="display:flex; align-items: center;">
                              <div style="display:flex; align-items: center;">
                                <div>Количество</div>
                                <div>
                                  <v-text-field
                                  v-model="changeTimeCount"
                                  outlined
                                  dense
                                  style="height: 45px;margin-top: 10px; width:50px; margin-left:10px;"
                                  class="rounded-lg"
                                  @keyup="keyUpdays"
                              ></v-text-field>
                                </div>
                              </div>
                              <div style="display:flex; align-items: center;">
                                <div style="margin-left:20px;">День</div>
                                <div style="margin-left:10px;"> 
                                  <!-- <v-text-field
                                  v-model="changeTimeDay"
                                  outlined
                                  readonly
                                  dense
                                  style="height: 45px;margin-top: 10px; width:150px; margin-left:10px;"
                                  class="rounded-lg"
                                >
                                  День
                              </v-text-field> -->
                                <v-select
                                  :items="changeTimeDayList"
                                  v-model="changeTimeDay"
                                  item-value="id"
                                  item-text="name"
                                  class="rounded-lg"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  background-color="white"
                                  return-object
                                  readonly
                                  style="height: 48px;padding-top: 5px; flex: none !important;"
                              >
                              </v-select>
                            </div>
                              </div>
                              <div style="display:flex; align-items: center;">
                                <div style="margin-left:20px;">До</div>
                                <div style="margin-left:10px; width:150px;">
                                  <VueDatePicker
                                      no-title
                                      no-header
                                      color="#629f34"
                                      v-model="changeTimeDate"
                                      placeholder="Дата"
                                      readonly
                                  >
                                    <template #activator="{ date }">
                                      <button
                                          class="button custom__datepicker"
                                          ref="activator"
                                          type="button"
                                      >
                                        <div>
                                          <span v-if="date">{{ date }}</span>
                                          <span v-else style="color: gray">Дата</span>
                                        </div>
                                        <div>
                                          <v-icon
                                              medium
                                              right
                                              class="ml-5"
                                          >
                                            mdi-calendar-blank-outline
                                          </v-icon>
                                        </div>
                                      </button>
                                    </template>
                                  </VueDatePicker>
                                </div>
                              </div>
                            </div>

                          </div>


                          <div v-if="operation === 'GuestVisits'">
                            <label style="color: #629F33;">Добавление гостевых посещений</label>
                              <div style="display:flex; align-items: center;">
                                <div>Количество</div>
                                <div>
                                  <v-text-field
                                  v-model="guest_visits_def"
                                  outlined
                                  dense
                                  style="height: 45px;margin-top: 10px; width:50px; margin-left:10px;"
                                  class="rounded-lg"
                              ></v-text-field>
                                </div>
                              </div>
                          </div>


                          <div v-if="operation !== 'ChangeNomenclature' && operation !== 'AddService' && modifier_id && modifier_id.free === false" style="width:20%;">Цена: {{ modifier_id.price }} </div>
                          <div v-else-if="operation !== 'ChangeNomenclature' && operation !== 'AddService'" style="width:20%;">Цена: бесплатно </div>

                    </div>

                    <div>
                      <v-textarea
                          v-model="operation_comment"
                          rounded
                          outlined
                          dense
                          required
                          auto-grow
                          placeholder="Комментарий к операции"
                          background-color="#fff"
                          rows="5"
                          style="width: 100%; height: 150px"
                      ></v-textarea>
                    </div>
               
                    <div class="column d-flex justify-space-between">
                        <v-btn
                        v-if="document_id" @click="removeDocument"
                              class="button__lighten ml-3"
                            >
                              <v-icon small class="mr-2">mdi-trash-can-outline</v-icon>
                              Удалить
                            </v-btn>
                      <div>
                        <v-btn
                            :to="{ name: 'SaleHistory', params: {client_id: client_id} }"
                            class="button__lighten ml-3"
                            v-if="operation !== 'ChangeTime' && operation !== 'GuestVisits'"
                        >
                          <img src="/playground_assets/clock-logo.svg" class="mr-1" alt="">
                          История
                        </v-btn>
                      </div>
                      <div>
                        <v-btn v-if="operation !== 'ChangeTime' && operation !== 'GuestVisits' && operation !== 'AddService'" class="button__success" type="submit">
                          Сменить
                        </v-btn>
                        <v-btn v-else class="button__success" type="submit">
                          Сохранить
                        </v-btn>
                      </div>
                    </div>
                  </v-sheet>
                </v-col>
              </v-form>
            </v-row>
          </v-container>
        </v-row>


        <v-row justify="center">
              <v-dialog
                  v-model="dialogDelete"
                  persistent
                  max-width="400px"
              >
                <v-form @submit.prevent="removeDocumentSubmit">
                  <v-card>
                    <v-card-title class="text-center">
                      <v-spacer></v-spacer>
                      <v-btn icon @click="dialogDelete = false">
                        <v-icon>mdi-close-circle-outline</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text style="padding-bottom: 30px;">
                      <v-container>
                        <div>
                          <h3 class="card-title">Вы уверены, что хотите удалить выбранный объект?</h3>
                        </div>
                        <v-row
                            align="center"
                            class="mt-5 justify-center"
                        >
                          <button
                              class="button button__danger"
                              ref="activator"
                              type="submit"
                          >
                            Да
                          </button>
                          <button
                              class="button button__unlock ml-5"
                              ref="activator"
                              type="button"
                              @click="dialogDelete = false"
                          >
                            Нет
                          </button>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-form>
              </v-dialog>
            </v-row>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {clientActionTypes} from '@/store/modules/client';
import {receptionActionTypes} from '@/store/modules/reception';
import {mapState} from "vuex";
import {getItem, setItem} from "../helpers/persistanceStorage";
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {VueDatePicker} from '@mathieustan/vue-datepicker';

export default {
  name: "ChangeOwner",
  props: ['client_id','product_id','change_type',
  'product_lastdate','closed_service_id','closed_service_name',
  'changetimedays','change_type_product','document_id','change_owner_new_client','change_owner_new_client_to',
  'document_modifier','document_comment'
],
  components: {
    Header,
    Menu,
    VueDatePicker
  },
  computed: {
    validationRules () {
      return this.maxNumberOfChoices ? [this.validateMaxNumberOfChoices] : []
    },
    ...mapState({
      listClient: state => state.client.listClient,
      visitorDesktop: state => state.reception.visitorDesktop,
      modifierList: state => state.client.modifierList,
      changeNomenclatureList: state => state.client.changeNomenclatureList,
      calcChangeNomenclature: state => state.client.calcChangeNomenclature
    }),
    searchPackages() {
      return this.visitorDesktop.client.productes.filter((i) => {
        return !this.searchPackages || (i.name.toLowerCase().includes(this.searchPackages.toLowerCase()));
      })
    }
  },
  data () {
    return {
      modifier_id:{name: 'Смена владельца (клеверспорт)', id: 'ee80e48c-08ab-11eb-8136-9c5c8e747603', price:'0 р'},
      maxNumberOfChoices:0,
      productRules: [
        v => !!v || 'Нужно выбрать членство, пакет услуг'
      ],
      newclient_id:null,
      newClientRules: [
        v => !!v || 'Нужно выбрать клиента'
      ],
      daysRules: [v => v.newclient_id.length >= 3 || "Please select a user"],
      search: '',
      searchPackage: '',
      modifier: [
        {name: 'Смена владельца (клеверспорт)', id: 'ee80e48c-08ab-11eb-8136-9c5c8e747603', price:'0 р'},
        {name: 'Смена владельца Бесплатно  (клеверспорт)', id: '0574b946-40ad-11ed-a062-60e32700ce56', price:'0 р'},
        {name: 'Переоформление клубной карты', id: 'c09455f6-ed16-11ea-812c-9c5c8e747603', price:'1100 р'}
      ],
      modifierNomenclature: [
        {name: 'Смена номенклатуры', id: 'ffc18c97-08ab-11eb-8136-9c5c8e747603'}
      ],
      modifierNomenclatureDef: [
        {name: 'Загрузка данных', id: 'ffc18c97-08ab-11eb-8136-9c5c8e747603'}
      ],
      modifier_id_def:{name: 'Загрузка данных', id: 'ffc18c97-08ab-11eb-8136-9c5c8e747603', price:'0 р'},
      modifierRules: [
        v => !!v || 'Нужно выбрать модификатор'
      ],
      dateFrom: null,
      dateTo: null,
      selectProduct: null,
      days: 0,
      operations: [
        {name: 'Заморозка', link: 'FreezePackage'},
        {name: 'Разморозка', link: 'UnfreezePackage'},
        {name: 'Смена владельца', link: 'ChangeOwner'},
        {name: 'Смена номенклатуры', link: 'ChangeNomenclature'},
        {name: 'Изменение срока действия', link: 'ChangeTime'},
        {name: 'Добавление гостевых посещений', link: 'GuestVisits'},
        {name: 'Добавление услуг', link: 'AddService'}
      ],
      operation: 'ChangeOwner',
      headersProductes: [
        {text: 'Дата', value: 'date'},
        {text: 'Товары и услуги', value: 'name'},
        {text: 'Вид операции', value: 'operation'},
        {text: 'Дата c', value: 'dateFrom'},
        {text: 'Дней', value: 'days'},
        {text: 'Услуга (сегмент)', value: 'segment'},
        {text: 'Кол-во', value: 'count'},
        {text: 'Сумма', value: 'sum'},
        {text: 'По договору', value: 'price'},
        {text: 'Дата до', value: 'dateTo'},
      ],
      newnomenclature_id:null,
      nomenclatureList:null,
      changeTimeDay:{"id":"day","name":"День"},
      changeTimeCount:0,
      changeTimeDate:new Date(),
      changeTimeDayList:[
        {"id":"day","name":"День"},
        {"id":"week","name":"Неделя"},
        {"id":"month","name":"Месяц"},
        {"id":"year","name":"Год"},
      ],
      product_id_closed:null,
      product_id_closed_items:[],
      guest_visits_def:0,
      dialogDelete:false,
      operation_comment:null,
      newclient_id_to:null
    }
  },
  methods: {
    removeDocumentSubmit(){
      this.$store.dispatch(receptionActionTypes.documentRemove, {
        document_id: this.document_id,
        comment:this.operation_comment
      })
      .then(() => {
        this.$router.push({
                  name: 'CardSubscribe',
                  params: {
                    client_id: this.client_id,
                    product_id:this.product_id
                  }
                });
        this.dialogDelete = false;
      })
    },
    removeDocument(){
      this.dialogDelete = true;
    },
    getNomenclaturePrice(){

      this.$store.dispatch(clientActionTypes.calcChangeNomenclature, {
          client_id: this.client_id,
          product_id: this.product_id,
          newnomenclature_id:this.newnomenclature_id,
        comment:this.operation_comment
        })
        .then((res) => {
          console.log(res)
        })

    },
    keyUpdays() {
      //if (this.dateFrom !== null) {
        var someDate = new Date()
        if(this.product_lastdate.split('.')[2]){
          someDate = new Date(new Date(this.product_lastdate.split('.')[2]+'-'+this.product_lastdate.split('.')[1]+'-'+this.product_lastdate.split('.')[0]));
        } else {
          someDate = new Date(this.product_lastdate);
        }
        
        

        //var duration = +this.changeTimeCount

        let timeCount = 0

        if(this.changeTimeDay.id === 'day'){
          timeCount = +this.changeTimeCount
        }
        if(this.changeTimeDay.id === 'week'){
          timeCount = +this.changeTimeCount*7
        }
        if(this.changeTimeDay.id === 'month'){
          timeCount = +this.changeTimeCount*30
        }
        if(this.changeTimeDay.id === 'year'){
          timeCount = +this.changeTimeCount*365
        }

        someDate.setTime(someDate.getTime() +  (timeCount * 24 * 60 * 60 * 1000))
        console.log('keyupdats')
        this.changeTimeDate = someDate
     // }
    },
    changeUsername(client) {
      console.log(client)
      this.newclient_id = client
    },
    validateMaxNumberOfChoices (selectedChoices)  {
      return selectedChoices.length <= this.maxNumberOfChoices || `Choose ${this.maxNumberOfChoices} at most.`
    },
    submitChangeOwner2() {
      if (this.$refs.addClientForm.validate()) {
        this.$store.dispatch(clientActionTypes.setChangeOwner, {
          client_id: this.client_id,
          product_id: this.product_id,
          newclient_id:this.newclient_id,
          modifier_id:this.modifier_id.id,
        comment:this.operation_comment
        })
            .then(() => {
              this.$router.push({
                name: 'CardClient',
                params: {
                  client_id: this.newclient_id
                }
              });
            })
      }
    },
    submitChangeOwner() {
      if(this.operation === 'ChangeNomenclature') {
        this.$store.dispatch(clientActionTypes.changeNomenclature, {
          client_id: this.client_id,
          product_id: this.product_id,
          newnomenclature_id:this.newnomenclature_id.id,
          modifier_id:this.modifier_id.id,
        comment:this.operation_comment
        })
            .then((res) => {

              let rroute = 'Desktop'

              if(this.change_type || this.change_owner_new_client) {
                rroute = 'CardSubscribe'
              }


              if(res.success) {
                this.$router.push({
                  name: rroute,
                  params: {
                    client_id: this.client_id
                  }
                });
              } else {
                alert('Не удалось провести: "Изменение условий членства, пакета услуг"!')
                this.$router.push({
                  name: rroute,
                  params: {
                    client_id: this.client_id
                  }
                });
              }
            })
      } else if(this.operation === 'ChangeOwner') {
        if (this.$refs.addClientForm.validate()) {
          this.$store.dispatch(clientActionTypes.setChangeOwner, {
            client_id: this.client_id,
            product_id: this.product_id,
            newclient_id:this.newclient_id,
            modifier_id:this.modifier_id.id,
        comment:this.operation_comment
          })
              .then(() => {

                let rroute = 'Desktop'

                if(this.change_type || this.change_owner_new_client) {
                  rroute = 'CardSubscribe'
                }

                this.$router.push({
                  name: rroute,
                  params: {
                    client_id: this.client_id
                  }
                });

              })
        }
      } else if(this.operation === 'ChangeTime'){

        let timeCount = 0
        if(this.changeTimeDay.id === 'day'){
          timeCount = +this.changeTimeCount
        }
        if(this.changeTimeDay.id === 'week'){
          timeCount = +this.changeTimeCount*7
        }
        if(this.changeTimeDay.id === 'month'){
          timeCount = +this.changeTimeCount*30
        }
        if(this.changeTimeDay.id === 'year'){
          timeCount = +this.changeTimeCount*365
        }

        console.log(timeCount)

        this.$store.dispatch(clientActionTypes.setChangeTime, {
            client_id: this.client_id,
            product_id: this.product_id,
            quantity: timeCount,
            modifier_id:this.modifier_id.id,
        comment:this.operation_comment
          })
              .then((res) => {

                let rroute = 'Desktop'

                if(this.change_type || this.change_owner_new_client) {
                  rroute = 'CardSubscribe'
                }

                if(res.success) {
                  this.$router.push({
                    name: rroute,
                    params: {
                      client_id: this.client_id
                    }
                  });
                } else {
                  alert('Не удалось провести: "Изменение условий членства, пакета услуг"!')
                  this.$router.push({
                    name: rroute,
                    params: {
                      client_id: this.client_id
                    }
                  });
                }

              })
      } else if(this.operation === 'GuestVisits') {
        //if (this.$refs.addClientForm.validate()) {
          this.$store.dispatch(clientActionTypes.setChangeOwner, {
            client_id: this.client_id,
            product_id: this.product_id,
            quantity:+this.guest_visits_def,
            modifier_id:this.modifier_id.id,
            guest_visits_type:true,
        comment:this.operation_comment
          })
              .then(() => {

                this.$router.push({
                  name: 'CardSubscribe',
                  params: {
                    client_id: this.client_id,
                    product_id:this.product_id
                  }
                });

              })
        //}
      } else if(this.operation === 'AddService') {
        this.$store.dispatch(clientActionTypes.changeNomenclature, {
          client_id: this.client_id,
          product_id: this.product_id,
          modifier_id:this.modifier_id.id,
          service_list:[{quantity:1,id:this.newnomenclature_id.id}],
        comment:this.operation_comment
        })
            .then((res) => {
              if(res.success) {
                this.$router.push({
                  name: 'CardSubscribe',
                  params: {
                    client_id: this.client_id,
                    product_id:this.product_id
                  }
                });
              } else {
                alert('Не удалось провести: "добаление услуги"!')
                this.$router.push({
                  name: 'CardSubscribe',
                  params: {
                    client_id: this.client_id,
                    product_id:this.product_id
                  }
                });
              }
            })
      }
    },
    fetchFeed(client_id,modifier_type) {
      this.$store.dispatch(receptionActionTypes.desktopClient, {client_id})

      this.$store.dispatch(clientActionTypes.getModifierList, {
          client_id: this.client_id,
          modifier_type: modifier_type
        })
        .then((res) => {
          console.log(res)
          if(res && res.data){
            let settedModifier = res.data[0]
            settedModifier.price = 0

            if(this.document_modifier) {
              this.modifier_id = this.document_modifier
              this.modifier_id.free = true
              this.modifier_id.price = 0
              this.modifier_id.fix = 0
            } else {
              this.modifier_id = settedModifier
            }

            
          }
        })

        this.$store.dispatch(clientActionTypes.changeNomenclatureList, {
          client_id: this.client_id,
          product_id: this.product_id,
        comment:this.operation_comment
        })
        .then((res) => {

          if(res && res.data){
            if(this.change_type_product && this.change_type_product.id){
              this.changeNomenclatureList.data.unshift({id:this.change_type_product.id,name:this.change_type_product.name})
              this.newnomenclature_id = this.change_type_product
            }
          }
          console.log(res)
        })

        
        // this.$store.dispatch(clientActionTypes.getModifierTypeList, {
        //   client_id: this.client_id
        // })
        // .then((res) => {
        //   console.log(res)
        // })
    },
    getBgColor(operation) {
      if (operation === 'FreezePackage') {
        return '#FBEBEA';
      } else if (operation === 'UnfreezePackage') {
        return '#E0ECD6';
      } else {
        return '#FFF8E6';
      }
    }
  },
  mounted() {
    this.client_id !== undefined ? setItem('change_owner-client_id', this.client_id) : this.client_id = getItem('change_owner-client_id');
    this.product_id !== undefined ? setItem('change_owner-product_id', this.product_id) : this.product_id = getItem('change_owner-product_id');
    
    if(this.change_type && this.change_type == 'nomenclature') {
      this.operation = 'ChangeNomenclature'
      //this.modifier_id = {name: 'Переоформление клубной карты', id: 'c09455f6-ed16-11ea-812c-9c5c8e747603', price:'1100 р'}

      this.fetchFeed(this.client_id,'Переоформление');

    } else if(this.change_type && this.change_type == 'owner') {
      this.operation = 'ChangeOwner'
      this.fetchFeed(this.client_id,'СменаВладельца');
    } else if(this.change_type && this.change_type == 'changetime') {
      this.operation = 'ChangeTime'

      console.log(this.changetimedays)

      if(this.changetimedays) {
        console.log(this.changetimedays)
        this.changeTimeCount = this.changetimedays
      }
      
      this.fetchFeed(this.client_id,'СрокДействия');

      if(this.closed_service_name){
        this.product_id_closed = {
          product_name: this.closed_service_name,
          product_id: this.closed_service_id
        }
        this.product_id_closed_items.push(this.product_id_closed)
        console.log('закрытый')
      }
    } else if(this.change_type && this.change_type == 'guest_visits'){
      this.operation = 'GuestVisits'
      this.fetchFeed(this.client_id,'ГостевыеВизиты');
    } else if(this.change_type && this.change_type == 'add_service'){
      this.operation = 'AddService'
      this.fetchFeed(this.client_id,'ДобавлениеУслуг');
    }


    this.changeTimeDate = (this.product_lastdate && this.product_lastdate.split('.000')[1]) ? (new Date()) : ((this.product_lastdate && this.product_lastdate.split('.')[2]) ? new Date(this.product_lastdate.split('.')[2]+'-'+this.product_lastdate.split('.')[1]+'-'+this.product_lastdate.split('.')[0]) : (this.product_lastdate && this.product_lastdate.split('T')[1]) ? this.product_lastdate.split('T')[0] : new Date())

    console.log(new Date())
    console.log(this.product_lastdate)
    console.log(this.changeTimeDate)

    console.log(new Date('2025-02-14'))

    if(this.change_owner_new_client) {
      this.newclient_id = this.change_owner_new_client
      this.newclient_id_to = this.change_owner_new_client_to
      //this.search = this.change_owner_new_client.name
    }

    if(this.document_comment) {
      this.operation_comment = this.document_comment
    }



    // [
    //     {
    //         "id": "СменаВладельца",
    //         "name": "Смена владельца"
    //     },
    //     {
    //         "id": "Переоформление",
    //         "name": "Смена номенклатуры"
    //     },
    //     {
    //         "id": "СрокДействия",
    //         "name": "Изменение срока действия"
    //     },
    //     {
    //         "id": "ГостевыеВизиты",
    //         "name": "Добавление гостевых визитов"
    //     },
    //     {
    //         "id": "СрокЗаморозки",
    //         "name": "Изменение срока заморозок"
    //     },
    //     {
    //         "id": "ДобавлениеУслуг",
    //         "name": "Добавление услуг"
    //     },
    //     {
    //         "id": "ДобавлениеПосещений",
    //         "name": "Добавление посещений"
    //     }
    // ],
  },
  watch: {
    search() {
      // console.log('cg')
      // console.log(this.search)

      // if(this.change_owner_new_client){
      //   //if(this.search === ''){
      //     this.search = this.change_owner_new_client.name
      //  // }
      // }

      if (this.search !== '' && !this.newclient_id) {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.search
        })
      }
    },
    operation(){
      if(this.operation === 'FreezePackage' || this.operation === 'UnfreezePackage'){
            this.$router.push({
              name: 'FreezePackage',
              params: {
                client_id: this.client_id,
                  product_id: this.product_id
              }
            });
      }

      if(this.operation === 'ChangeNomenclature') {

        this.fetchFeed(this.client_id,'Переоформление');

      } else if(this.operation === 'ChangeOwner') {
        this.fetchFeed(this.client_id,'СменаВладельца');
      } else if(this.operation === 'ChangeTime') {
        this.fetchFeed(this.client_id,'СрокДействия');
      } else if(this.operation === 'GuestVisits') {
        this.fetchFeed(this.client_id,'ГостевыеВизиты');
      } else if(this.operation === 'AddService') {
        this.fetchFeed(this.client_id,'ДобавлениеУслуг');
      }

      // if(this.operation === 'ChangeNomenclature') {
      //   this.modifier_id = {name: 'Переоформление клубной карты', id: 'c09455f6-ed16-11ea-812c-9c5c8e747603', price:'1100 р'}
      // } else {
      //   this.modifier_id = {name: 'Смена владельца (клеверспорт)', id: 'ee80e48c-08ab-11eb-8136-9c5c8e747603', price:'0 р'}
      // }

    },
    // changeTimeDate(){
      
    //   let dateFrom = new Date()
    //   console.log(dateFrom)
    //   //if (dateFrom !== null && this.dateTo !== null) {
    //     let decrSum = new Date(this.changeTimeDate).getTime() - dateFrom.getTime()

    //     console.log(decrSum)
    //     if(decrSum > 0){
    //       let countRes = Math.trunc(decrSum/(60*60*24*100*10))

    //       let timeCount = 0

    //       if(this.changeTimeDay.id === 'day'){
    //         timeCount = countRes
            
    //       }
    //       if(this.changeTimeDay.id === 'week'){
    //         timeCount = Math.round(+countRes/7)
            
    //         if(timeCount < 1) {
    //           this.changeTimeDay.id = 'day'
    //           timeCount = countRes
    //         } 

    //       }
    //       if(this.changeTimeDay.id === 'month'){
    //         timeCount = Math.round(+countRes/30)

    //         if(timeCount < 1) {
    //           this.changeTimeDay.id = 'week'
    //           timeCount = Math.round(+countRes/7)
    //         }

    //       }
    //       if(this.changeTimeDay.id === 'year'){
    //         timeCount = Math.round(+countRes/365)

    //         if(timeCount < 1) {
    //           this.changeTimeDay.id = 'month'
    //           timeCount = Math.round(+countRes/30)
    //         }

    //       }

    //       this.changeTimeCount = timeCount

    //     } else {
    //       this.changeTimeCount = 0
    //     }
    //   //}
    // }
  }
}
</script>

<style scoped>
.vd-activator .custom__datepicker {
  width: 89% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: space-between !important;
  margin-top: 5px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}
.hint {
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #767676;
}
</style>